import { paperClasses } from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';

import { menuItemClasses } from '@mui/material/MenuItem';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { iconButtonClasses } from '@mui/material/IconButton';
import { checkboxClasses } from '@mui/material/Checkbox';
import { listClasses } from '@mui/material/List';
import { gridClasses } from '@mui/x-data-grid-pro';
import { tablePaginationClasses } from '@mui/material/TablePagination';
import { gray } from '../../../shared-theme/themePrimitives';

const CloseSVG = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9998 2.5C14.5191 2.50054 16.9354 3.50151 18.7166 5.2832C21.9208 8.48845 22.4148 13.5113 19.8962 17.2793C17.3777 21.0472 12.5479 22.5113 8.36108 20.7764C4.17414 19.0412 1.79534 14.5895 2.68042 10.1445C3.56557 5.69966 7.4676 2.49907 11.9998 2.5ZM12.0007 3.5C9.74458 3.49263 7.57943 4.38801 5.98706 5.98633C3.11819 8.85201 2.67286 13.3448 4.92358 16.7178C7.17426 20.0906 11.4937 21.4045 15.241 19.8555C18.9883 18.3062 21.12 14.3253 20.3318 10.3477C19.5436 6.37022 16.0555 3.50342 12.0007 3.5ZM14.4734 8.81348C14.6702 8.61665 14.9894 8.61671 15.1863 8.81348C15.3828 9.01002 15.3832 9.32845 15.1873 9.52539L13.0574 11.6455L12.7009 12L13.0574 12.3545L15.1873 14.4746H15.1882C15.2829 14.5685 15.3357 14.6968 15.3357 14.8301C15.3357 14.9632 15.2826 15.0907 15.1882 15.1846C15.0939 15.2782 14.9657 15.3308 14.8328 15.3301H14.8269C14.694 15.3308 14.5658 15.2781 14.4714 15.1846L12.3542 13.0576L11.9998 12.7012L11.6453 13.0576L9.52808 15.1846C9.43372 15.2782 9.30553 15.3308 9.17261 15.3301H9.16675C9.03395 15.3307 8.90653 15.2781 8.81226 15.1846C8.71769 15.0907 8.66384 14.9633 8.66382 14.8301C8.66382 14.7303 8.69404 14.6335 8.74878 14.5518L8.81226 14.4746L10.9431 12.3545L11.2986 12L10.9431 11.6455L8.81226 9.52539C8.61658 9.32847 8.61685 9.00996 8.81323 8.81348C9.01003 8.61668 9.32925 8.61679 9.52612 8.81348L11.6453 10.9424L11.9998 11.2988L12.3542 10.9424L14.4734 8.81348Z" fill="white" stroke="white" /></svg>
)

const ErrorSVG = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0303 0.500977C10.5954 0.513235 11.1041 0.867724 11.332 1.47559L11.3418 1.50293L11.3555 1.52832L19.2549 16.9277L19.2607 16.9385L19.2656 16.9482C19.5764 17.4921 19.5709 18.1801 19.1934 18.709L19.1787 18.7295L19.166 18.752C18.8776 19.2568 18.3711 19.5 17.7002 19.5H2.2002C1.61636 19.5 1.01788 19.248 0.734375 18.752C0.422217 18.2057 0.422225 17.4945 0.734375 16.9482L0.739258 16.9385L0.745117 16.9277L8.64453 1.52832L8.65234 1.5127L8.65918 1.49707C8.87922 0.983643 9.40415 0.590027 10.0303 0.500977ZM9.55469 1.97168L1.67871 17.3252C1.57148 17.4685 1.53494 17.6254 1.51953 17.7178C1.49934 17.8389 1.5 17.9529 1.5 18V18.5H18.4004V18C18.4004 17.9529 18.4011 17.8389 18.3809 17.7178C18.3656 17.6259 18.3284 17.4708 18.2227 17.3281L10.4463 1.97363L10.0029 1.09863L9.55469 1.97168ZM10 14.5C10.2761 14.5 10.5 14.7239 10.5 15C10.5 15.2761 10.2761 15.5 10 15.5C9.72386 15.5 9.5 15.2761 9.5 15C9.5 14.7239 9.72386 14.5 10 14.5ZM10 7.5C10.1864 7.5 10.3025 7.5603 10.3711 7.62891C10.4397 7.69752 10.5 7.81362 10.5 8V12C10.5 12.1864 10.4397 12.3025 10.3711 12.3711C10.3025 12.4397 10.1864 12.5 10 12.5C9.81362 12.5 9.69752 12.4397 9.62891 12.3711C9.5603 12.3025 9.5 12.1864 9.5 12V8C9.5 7.81362 9.5603 7.69752 9.62891 7.62891C9.69752 7.5603 9.81362 7.5 10 7.5Z" fill="white" stroke="white" />
  </svg>
)

const SuccessSVG = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.8259 18.5C12.034 19.1394 11.0395 19.5 9.99976 19.5C8.96021 19.4999 7.96639 19.1392 7.17456 18.5H12.8259ZM9.99976 0.5C14.1419 0.5 17.4998 3.85786 17.4998 8L17.5017 12.3154V12.5176L17.6423 12.6621C17.6772 12.6982 17.7063 12.7403 17.7292 12.7861L17.7615 12.8652L19.0847 16.8438V16.8447C19.1341 16.9961 19.1082 17.1626 19.0154 17.292C18.9353 17.4033 18.8134 17.4751 18.6794 17.4941L18.5994 17.5H1.38354C1.22321 17.4987 1.07324 17.4207 0.980225 17.29C0.899941 17.1773 0.870776 17.0373 0.897217 16.9033L0.917725 16.8262L2.2439 12.8369C2.26831 12.766 2.30849 12.7037 2.35815 12.6523L2.49878 12.5068V12.3047L2.49976 8C2.49976 3.85796 5.85776 0.500159 9.99976 0.5ZM2.96558 13.8408L2.29565 15.8408L2.07495 16.5H17.9246L17.7039 15.8408L17.0339 13.8408L16.9197 13.5H3.07983L2.96558 13.8408ZM9.99976 1.5C6.41004 1.50016 3.49976 4.41025 3.49976 8V12.499H16.4998V8C16.4998 4.49163 13.7202 1.63304 10.2429 1.50488V1.50391H10.2341L10.0095 1.5H9.99976Z" fill="white" stroke="white" />
  </svg>
)

/* eslint-disable import/prefer-default-export */
export const dataGridCustomizations = {
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        width: '100%',
        fontFamily: 'New Transport',
        fontSize: '16px'
      },
      filledSuccess: {
        backgroundColor: '#06757F',
        color: '#ffffff'
      },
      filledError: {
        backgroundColor: '#DA0076'
      }
    },
    defaultProps: {
      slots: {
        closeIcon: CloseSVG,
      },
      iconMapping: {
        error: <ErrorSVG />,
        success: <SuccessSVG />
      }
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      root: ({ theme }) => ({
        '--DataGrid-overlayHeight': '300px',
        overflow: 'clip',
        borderColor: (theme.vars || theme).palette.divider,
        backgroundColor: (theme.vars || theme).palette.background.default,
        [`& .${gridClasses.columnHeader}`]: {
          backgroundColor: (theme.vars || theme).palette.background.paper,
        },
        [`& .${gridClasses.footerContainer}`]: {
          backgroundColor: (theme.vars || theme).palette.background.paper,
        },
        [`& .${checkboxClasses.root}`]: {
          padding: theme.spacing(0.5),
          '& > svg': {
            fontSize: '1rem',
          },
        },
        [`& .${tablePaginationClasses.root}`]: {
          marginRight: theme.spacing(1),
          '& .MuiIconButton-root': {
            maxHeight: 32,
            maxWidth: 32,
            '& > svg': {
              fontSize: '1rem',
            },
          },
        },
      }),
      cell: ({ theme }) => ({
        borderTopColor: (theme.vars || theme).palette.divider,
      }),
      menu: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        backgroundImage: 'none',
        [`& .${paperClasses.root}`]: {
          border: `1px solid ${(theme.vars || theme).palette.divider}`,
        },
        [`& .${menuItemClasses.root}`]: {
          margin: '0 4px',
        },
        [`& .${listItemIconClasses.root}`]: {
          marginRight: 0,
        },
        [`& .${listClasses.root}`]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      }),
      row: ({ theme }) => ({
        '&:last-of-type': {
          borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        },
        '&:hover': {
          backgroundColor: (theme.vars || theme).palette.action.hover,
        },
        '&.Mui-selected': {
          background: (theme.vars || theme).palette.action.selected,
          '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
          },
        },
      }),
      iconButtonContainer: ({ theme }) => ({
        [`& .${iconButtonClasses.root}`]: {
          border: 'none',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: alpha(theme.palette.action.selected, 0.3),
          },
          '&:active': {
            backgroundColor: gray[200],
          },
        },
      }),
      menuIconButton: () => ({
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: gray[100],
        },
        '&:active': {
          backgroundColor: gray[200],
        },
      }),
      filterForm: ({ theme }) => ({
        gap: theme.spacing(1),
        alignItems: 'flex-end',
      }),
      columnsManagementHeader: ({ theme }) => ({
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
      }),
      columnHeaderTitleContainer: {
        flexGrow: 1,
        justifyContent: 'space-between',
      },
      columnHeaderDraggableContainer: { paddingRight: 2 },
    },
  },
};
